import React from 'react';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import { Presentation } from './pages/Presentation';
import { UseCasePage } from './pages/UseCasePage';
export function App() {
  return <BrowserRouter data-id="element-0">
      <div className="w-full h-screen" data-id="element-1">
        <Routes data-id="element-2">
          <Route path="/" element={<Presentation data-id="element-4" />} data-id="element-3" />
          <Route path="/use-case" element={<UseCasePage data-id="element-6" />} data-id="element-5" />
        </Routes>
      </div>
    </BrowserRouter>;
}